import React, { Component, PropTypes } from 'react'
import Link from 'gatsby-link'

import AHref from '../../components/AHref'
import TextBlock from '../../components/TextBlock'
import RowDetail from '../../components/RowDetail'

import './index.scss'

class ProjectDetails extends Component {
  render () {
    const { children, client, agency, agencylink, deliverables, duration, link, role, credit1, credit2 } = this.props

    let roleContainer, clientContainer, agencyContainer, deliverablesContainer, durationContainer, linkContainer

    if (role) {
      roleContainer = (
        <RowDetail title="Role" value={role} />
      )
    }

    if (client) {
      clientContainer = (
        <RowDetail title="Client" value={client} />
      )
    }

    if (duration) {
      durationContainer = (
        <RowDetail title="Project Duration" value={duration} />
      )
    }

    if (deliverables) {
      deliverablesContainer = (
        <RowDetail title="Contributions" value={deliverables} />
      )
    }

    if (agency) {
      agencyContainer = (
        <RowDetail title="Created at" value={<AHref url={agencylink}>{agency}</AHref>} />
      )
    }

    if (link) {
      linkContainer = (
        <RowDetail title="Link" value={<AHref url={link}>{link}</AHref>} />
      )
    }

    return (
      <div className="inner project-details">
        <div className="row between-xs">
          <div className="col-xs-16 col-md-5 project-meta">
            {roleContainer}
            {clientContainer}
            {durationContainer}
            {deliverablesContainer}
            {agencyContainer}
            {linkContainer}
            {credit1}
            {credit2}
          </div>
          <div className="col-xs-16 col-md-9 project-overview">
            {children}
          </div>
        </div>
      </div>
    )
  }
}

ProjectDetails.propTypes = {
  children: PropTypes.node,
  role: PropTypes.string,
  client: PropTypes.string,
  duration: PropTypes.string,
  agency: PropTypes.string,
  agencylink: PropTypes.string,
  link: PropTypes.string,
  deliverables: PropTypes.string,
  credit1: PropTypes.node,
  credit2: PropTypes.node,
}

export default ProjectDetails



// WEBPACK FOOTER //
// ./src/components/ProjectDetails/index.js